module.exports = __webpack_public_path__ + "img/background.597771ad.jpg";